<mat-toolbar class="header">
  <div class="back" mat-dialog-close matTooltip="Atrás" matTooltipPosition="right">
    <mat-icon >arrow_back_ios_new</mat-icon>
  </div>
  <div>
  {{ data.title }}
  </div>
</mat-toolbar>


<div class="dialog-wrapper" >
  <div #wrapper>
    <form [formGroup]="form">
      <div class="form-row">
        <mat-form-field class="field">
          <mat-label>Bodega Origen</mat-label>
          <mat-select formControlName="warehouse_id" required>
            @for (warehouse of warehouses$ | async; track warehouse.id) {
              <mat-option [value]="warehouse.id">
                {{ warehouse.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <div class="icon-container">
          <i class="fas fa-arrow-right"></i>
        </div>
        <mat-form-field class="field">
          <mat-label>Bodega Destino</mat-label>
          <mat-select formControlName="target_warehouse_id" required>
            @for (warehouse of targetWarehouses(); track warehouse.id) {
              <mat-option [value]="warehouse.id">
                {{ warehouse.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      @if (form.get('warehouse_id').value) {
        <div>
          <app-inventory-action-form
            [parentFormGroup]="(form | formGroup)"
            [enableDiscounts]="false"
            [showTotals]="false"
            [filterCategories]="inventoriableCategoriesIds"
            [filterWarehouses]="[form.get('warehouse_id').value]"
            [showBuyPrice]="true"
            [stockFilter]="{ minStock: 1 }"
            [validateStock]="true"
            [onlyInventoriable]="true"
            >
          </app-inventory-action-form>
        </div>
      }
    </form>
  </div>
</div>

<mat-toolbar class="footer">
  <button mat-raised-button mat-dialog-close> 
    Cancelar
  </button>
  <div class="expander"></div>
  <button mat-raised-button
          type="button"
          color="primary"
          [disabled]="!formValid || loading()"
          (click)="saveForm()">
    @if (loading()) {
      <mat-spinner diameter="30"></mat-spinner>
    } @else {
      Crear/Iniciar
    }      
  </button>
</mat-toolbar>
